import { getCartIconControllerConfig } from './getCartIconControllerConfig';
export function createInternalOnlineStoresOnlyExports(_a) {
    var context = _a.context;
    var getCartIconCompIdAndExternalId = function () {
        var cartIconControllerConfig = getCartIconControllerConfig(context);
        if (!cartIconControllerConfig) {
            return null;
        }
        return {
            externalId: cartIconControllerConfig.config.externalId,
            compId: cartIconControllerConfig.compId,
        };
    };
    return {
        getCartIconCompIdAndExternalId: getCartIconCompIdAndExternalId,
    };
}
//# sourceMappingURL=createInternalOnlineStoresOnly.js.map